import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _Messenger, _window$msrc, _window$msrc$messenge;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-dupe-class-members,@typescript-eslint/no-explicit-any,no-restricted-globals */
import mitt from 'mitt';
class Messenger {
  constructor() {
    _defineProperty(this, "emitter", void 0);
    _defineProperty(this, "currentData", {
      'stores:locate': null,
      'community:delete-reaction': null,
      'community:add-review': null,
      'community:edit-review': null,
      'community:add-comment': null,
      'community:edit-comment': null,
      'community:load-more-reviews': null,
      'community:toggle-review-form': null,
      'community:add-question': null,
      'community:add-discussion': null,
      'community:edit-question': null,
      'community:edit-discussion': null,
      'community:add-answer': null,
      'community:edit-answer': null,
      'community:load-more-questions': null,
      'community:load-more-discussions': null,
      'community:toggle-question-form': null,
      'community:toggle-discussion-form': null,
      'community:add-like': null,
      'community:delete-like': null,
      'community:add-kudo': null,
      'community:delete-kudo': null,
      'community:set-alias': null,
      'login:authenticate': {
        isManualLogin: false,
        loggedIn: false,
        error: null
      },
      'login:token-renew': {
        token: ''
      },
      'login:toggle-flyout': null,
      'articles:product-not-found': null,
      'router:navigate': null
    });
    _defineProperty(this, "unsubscribe", (messageType, callback) => this.emitter.off(messageType, callback));
    _defineProperty(this, "get", messageType => this.currentData[messageType]);
    this.emitter = mitt();
  }
  static getInstance() {
    if (Messenger.instance === undefined) {
      Messenger.instance = new Messenger();
    }
    return Messenger.instance;
  }
  publish(messageType, data) {
    this.currentData = _objectSpread(_objectSpread({}, this.currentData), {}, {
      [messageType]: data
    });
    this.emitter.emit(messageType, data);
  }
  subscribe(messageType, callback) {
    this.emitter.on(messageType, callback);
  }
}
_Messenger = Messenger;
_defineProperty(Messenger, "instance", void 0);
const hasWindow = typeof window !== 'undefined';
const messengerInstance = hasWindow ? (_window$msrc = window.msrc) === null || _window$msrc === void 0 ? void 0 : (_window$msrc$messenge = _window$msrc.messenger) === null || _window$msrc$messenge === void 0 ? void 0 : _window$msrc$messenge._current : undefined;
export const messenger = messengerInstance || Messenger.getInstance();
if (hasWindow && messengerInstance === undefined) {
  window.msrc = window.msrc || {};
  window.msrc.messenger = _objectSpread(_objectSpread({}, window.msrc.messenger), {}, {
    _current: messenger
  });
}